<template>
  <div class="set-phone">
    <p class="title">注册成功</p>

    <p class="notice">系统需要进一步验证你的手机号</p>

    <div class="tab">
      <div class="tab-con">
        <p :class="['tab-item', phoneType === 0 ? 'cur' : '' ]" @click="phoneType = 0">国内号码</p>
        <p :class="['tab-item', phoneType === 1 ? 'cur' : '' ]" @click="phoneType = 1">国外号码</p>
      </div>
    </div>

    <div>
      <div class="input_phone">
        <input type="tel" v-model="phone" class="input" placeholder="请输入手机号码" />
          <a href="javascript:;" class="btn" @click="getCode" :disabled="ifSend" >{{btnText}}
            <van-count-down class="count" :auto-start="false"  :time="time" format="ss 秒" ref="countdown"
              @finish="finished()" v-show="ifSend == true" />
          </a>
      </div>

      <div class="input_code">
        <input type="tel" v-model="code" class="input" placeholder="请输入验证码" />
      </div>
    </div>
    <p class="wrong" v-if="ifMatch === false">手机验证码错误</p>
    <div class="complet">
      <a class="content-btn selected"  @click="complete()">完成</a>
    </div>
  </div>

</template>

<script>
  import { mapState, mapMutations } from 'vuex'
  import { CountDown } from 'vant'
  export default {
    computed: {
      ...mapState({
        userData: 'userData'
      })
    },
    data () {
      return {
        phoneType: 0,
        phone: '',
        code: "",
        ifMatch: true,
        ifSend: false,
        btnText: "发送验证码",
        time: 60 * 1000,
        phoneData: {}
      }
    },
    watch: {
      userData: {
        handler (val) {
          this.phone = val.mobile
        },
        immediate: true
      }
    },
    methods: {
      ...mapMutations({
        updateUserData: 'updateUserData'
      }),
      initCountdown () {
        this.ifSend = false;
        this.btnText = "发送验证码";
        this.$refs.countdown.reset()
      },
      finished () {
        this.initCountdown()
      },
      countStart(){
        const countDown = this.selectComponent('.count');
        countDown.start();
      },
      getCode () {
        if (!this.phone) {
          return this.$toast('请填写手机号')
        }
        let tempData = {}
        tempData.mobile = this.phone
        tempData.ifAbroad = this.phoneType
        this.$root.openLoading()
        this.$http(`/api/member/sms/sendCode`,
          tempData
        ).then(res => {
          this.$root.closeLoading()
          if (res.code === '0000') {
            this.ifSend = true
            this.btnText = "剩余 "
            this.$refs.countdown.start()
          } else {
            this.$toast(res.msg)
          }
        }, err => {
          this.$toast(err)
          this.$root.closeLoading()
        })
      },
      complete () {
        if (!this.phone) {
          return this.$toast('请填写手机号')
        }
        if (!this.code) {
          return this.$toast('请填入验证码')
        }
        this.$root.openLoading()
        this.$http('/api/member/sms/checkCode', {
          mobile: this.phone,
          code: this.code,
          type: 1
        }, 'get').then(res => {
          this.$root.closeLoading()
          if (res.code === '0000') {
            if (res.data.result === 1) {
              this.updateUserData({
                mobile: this.phone,
                ifMobileVerify: 1
              })
              this.$nextTick(() => {
                this.$router.replace('/account.html')
              })
            }else {
              this.ifMatch = false
            }
          } else {
            this.ifMatch = false
            this.$toast(res.msg)
          }
        }, (res) => {
          this.$toast('请填入正确的验证码')
          this.ifMatch = false
          this.$root.closeLoading()
        })
      }
    }
  }
</script>
